module.exports = "<app-chart\n  [title]=\"'Utolsó perc'\"\n  [chartType]=\"chartType\"\n  [chartData]=\"chartData\"\n  [chartOptions]=\"chartOptions\"\n  [chartResponsive]=\"chartResponsive\"\n  [legendItems]=\"chartLegendItems\"\n  [withHr]=\"true\"\n  [footerIconClass]=\"'fa fa-history'\"\n  [footerText]=\"'frissül öt másodpercenként'\">\n</app-chart>\n"


//////////////////
// WEBPACK FOOTER
// /builds/iws/vanenet/src/app/main/history/history.component.html
// module id = ../../../../../src/app/main/history/history.component.html
// module chunks = main.module